import { useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { useAdminAuth } from "@/context/AdminAuthContext";
import { AdminHeading, Card, Field, inputCls } from "@/components/admin/ui";
import { ROLE_LABELS } from "@/components/admin/ui";

export default function MyAccount() {
  const { admin } = useAdminAuth();
  const [f, setF] = useState({ current_password: "", new_password: "" });
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try { await api.post("/auth/change-password", f); toast.success("Password changed"); setF({ current_password: "", new_password: "" }); }
    catch (err) { toast.error(formatApiError(err)); }
    finally { setBusy(false); }
  };
  return (
    <div data-testid="admin-account">
      <AdminHeading title="My account" />
      <Card className="p-6 max-w-lg">
        <div className="font-semibold">{admin.name}</div>
        <div className="text-sm text-[var(--ink-soft)]">{admin.email} · {ROLE_LABELS[admin.role]}</div>
        <form onSubmit={submit} className="mt-6 space-y-4" data-testid="change-password-form">
          <Field label="Current password"><input type="password" required value={f.current_password} onChange={(e) => setF((x) => ({ ...x, current_password: e.target.value }))} className={inputCls} data-testid="current-password-input" /></Field>
          <Field label="New password" hint="At least 8 characters"><input type="password" required minLength={8} value={f.new_password} onChange={(e) => setF((x) => ({ ...x, new_password: e.target.value }))} className={inputCls} data-testid="new-password-input" /></Field>
          <button disabled={busy} className="btn-leaf" data-testid="change-password-submit">{busy && <Loader2 size={16} className="animate-spin" />} Update password</button>
        </form>
      </Card>
    </div>
  );
}
